import { render, staticRenderFns } from "./AdminNonMetrcBrowseGroupModal.vue?vue&type=template&id=2ef5f88c"
import script from "./AdminNonMetrcBrowseGroupModal.vue?vue&type=script&lang=js"
export * from "./AdminNonMetrcBrowseGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef5f88c')) {
      api.createRecord('2ef5f88c', component.options)
    } else {
      api.reload('2ef5f88c', component.options)
    }
    module.hot.accept("./AdminNonMetrcBrowseGroupModal.vue?vue&type=template&id=2ef5f88c", function () {
      api.rerender('2ef5f88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminNonMetrcBrowseGroupModal.vue"
export default component.exports